/**
 * 追従バナー(sections/custom-floating-banner.liquid)。
 *
 * 表示期間の判定を端末の時計で行う。Liquid の 'now' はページのキャッシュで古くなるため。
 * 日時は日本時間として読むので、端末のタイムゾーンが違っても同じ瞬間に切り替わる。
 * テーマエディタの中(data-preview)では、期間に関係なく表示する。日時が読めないときは表示しない。
 *
 * 閉じるボタンはドキュメントで拾うので、テーマエディタでセクションが再描画されても動く。
 */
(function () {
  // テーマエディタが再描画のたびにこのファイルを読み直しても、二重に動かさない。
  var root = document.documentElement;
  if (root.hasAttribute('data-custom-floating-banner-ready')) return;
  root.setAttribute('data-custom-floating-banner-ready', '');

  var JST_OFFSET = 9 * 60 * 60 * 1000;
  var PATTERN = /^(\d{4})-(\d{1,2})-(\d{1,2})[ T]+(\d{1,2}):(\d{2})(?::(\d{2}))?$/;

  // 共通ルール「外部リンクの別タブ表示」と同じく、お客様アカウントのホストもサイト内として扱う。
  var INTERNAL_HOSTS = [location.hostname, 'account.' + location.hostname, 'shopify.com'];

  // 「2026-09-19 00:00」を日本時間の瞬間(ミリ秒)にする。空欄は null、読めなければ NaN。
  // 全角、「/」区切り、Mac の日本語入力の「−」や長音の「ー」、秒つき、「24:00」(翌日の 0:00)も通す。
  function parse(value) {
    var text = String(value || '')
      .normalize('NFKC')
      .trim()
      .replace(/[‐-―−ー\/]/g, '-');
    if (!text) return null;

    var match = text.match(PATTERN);
    if (!match) return NaN;

    var year = Number(match[1]);
    var month = Number(match[2]) - 1;
    var day = Number(match[3]);
    var hour = Number(match[4]);
    var minute = Number(match[5]);
    var second = Number(match[6] || 0);

    // 2月30日のように、繰り上がって別の日になるものは書式違いとして扱う。
    var date = new Date(Date.UTC(year, month, day));
    if (date.getUTCMonth() !== month || date.getUTCDate() !== day) return NaN;
    if (minute > 59 || second > 59 || hour > 24 || (hour === 24 && (minute || second))) return NaN;

    return Date.UTC(year, month, day, hour, minute, second) - JST_OFFSET;
  }

  // 期間を返す。どちらかが読めない、または開始が終了より後なら null。
  function readPeriod(banner) {
    var start = parse(banner.getAttribute('data-start'));
    var end = parse(banner.getAttribute('data-end'));

    if (Number.isNaN(start) || Number.isNaN(end)) return null;
    if (start !== null && end !== null && start >= end) return null;
    return { start: start, end: end };
  }

  function isInPeriod(period, now) {
    if (period.start !== null && now < period.start) return false;
    if (period.end !== null && now >= period.end) return false;
    return true;
  }

  function isImageReady(banner) {
    var image = banner.querySelector('img');
    return !image || (image.complete && image.naturalWidth > 0);
  }

  // 画像は loading="lazy" で描くので、hidden の間は読まれない(期間外のページで読まない)。
  // 表示するときに読み始め、読み終えてから見せる。空の枠と閉じるボタンだけが出ないように。
  function loadImage(banner) {
    var image = banner.querySelector('img');
    if (image.hasAttribute('data-custom-floating-banner-loading')) return;

    image.setAttribute('data-custom-floating-banner-loading', '');
    image.addEventListener('load', function () {
      apply(banner);
    }, { once: true });
    image.loading = 'eager';
  }

  // mailto: や tel: は対象にしない。新しいタブで開くのは外部のサイトだけ。
  function setLinkTarget(banner) {
    var link = banner.querySelector('a[href]');
    if (!link || !/^https?:$/.test(link.protocol)) return;
    if (INTERNAL_HOSTS.indexOf(link.hostname) !== -1) return;

    link.target = '_blank';
    link.relList.add('noopener', 'noreferrer');
  }

  function apply(banner) {
    if (banner.hasAttribute('data-closed')) return;

    var period = readPeriod(banner);
    var visible = period !== null && (banner.hasAttribute('data-preview') || isInPeriod(period, Date.now()));

    if (visible && !isImageReady(banner)) {
      loadImage(banner);
      visible = false;
    }
    banner.hidden = !visible;
  }

  function applyAll() {
    document.querySelectorAll('[data-custom-floating-banner]').forEach(function (banner) {
      setLinkTarget(banner);
      apply(banner);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-custom-floating-banner-close]');
    if (!button) return;

    var banner = button.closest('[data-custom-floating-banner]');
    banner.setAttribute('data-closed', '');
    banner.hidden = true;
  });

  document.addEventListener('shopify:section:load', applyAll);

  // ページを開いたまま開始・終了の時刻をまたいでも切り替わるように、30秒ごとに見直す。
  setInterval(applyAll, 30 * 1000);

  applyAll();
})();
